import { Injectable } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, AbstractControl } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class FormService {

  constructor(private fb: UntypedFormBuilder) {
  }

  /**
   * It returns if control has specific error is validator is passed, other way it
   * returns if control has any error
   *
   * @param control
   * @param validator
   * @returns
   */
  public controlHasError(control: AbstractControl, validator?: string): boolean {
    if (!validator) {
      return !control.disabled && !control.valid && (control.dirty || control.touched);
    }
    return control.hasError(validator) && (control.dirty || control.touched);
  }

  public createForm(formOptions): UntypedFormGroup {
    return this.fb.group(formOptions);
  }

  /**
   * It returns false if form is invalid and true if it valid.
   * If it's invalid we refresh validation and show the errors.
   */
  public validateFormAndUpdateErrors(formGroup: UntypedFormGroup) {
    formGroup.updateValueAndValidity();

    if (formGroup.invalid) {
      Object.keys(formGroup.controls).forEach(key => {
        formGroup.get(key).markAsTouched();
      });
      return false;
    }
    return true;
  }

}
